// Polyfill Array/String.prototype.at for Android WebView < Chrome 92
// Must be a separate module imported before any other import in index.jsx
// because ES module imports are hoisted — inline polyfill code runs too late.
if (!Array.prototype.at) {
  Array.prototype.at = function(n) {
    n = Math.trunc(n) || 0;
    if (n < 0) n += this.length;
    return (n < 0 || n >= this.length) ? undefined : this[n];
  };
}
if (!String.prototype.at) {
  String.prototype.at = function(n) {
    n = Math.trunc(n) || 0;
    if (n < 0) n += this.length;
    return (n < 0 || n >= this.length) ? undefined : this[n];
  };
}
